'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _web3Utils = require('web3-utils');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EthereumAddress = require('../EthereumAddress');

var _EthereumAddress2 = _interopRequireDefault(_EthereumAddress);

var _safeToBn = require('../../utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BrowserPaymentMethod = function (_React$PureComponent) {
  _inherits(BrowserPaymentMethod, _React$PureComponent);

  function BrowserPaymentMethod(props) {
    _classCallCheck(this, BrowserPaymentMethod);

    var _this = _possibleConstructorReturn(this, (BrowserPaymentMethod.__proto__ || Object.getPrototypeOf(BrowserPaymentMethod)).call(this, props));

    _this.state = {
      showDetails: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(BrowserPaymentMethod, [{
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ showDetails: !this.state.showDetails });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          close = _props.close,
          passClose = _props.passClose,
          _props$transaction = _props.transaction,
          data = _props$transaction.data,
          _props$transaction$se = _props$transaction.sendOptions,
          gasPrice = _props$transaction$se.gasPrice,
          gasLimit = _props$transaction$se.gas,
          _props$transaction$se2 = _props$transaction$se.value,
          value = _props$transaction$se2 === undefined ? 0 : _props$transaction$se2,
          contract = _props$transaction.contract,
          formattedTokenAmount = _props$transaction.formattedTokenAmount,
          walletType = _props.walletType;
      var showDetails = this.state.showDetails;


      var tokenAmount = formattedTokenAmount || null;
      var gasFee = (0, _safeToBn2.default)(gasLimit).mul((0, _safeToBn2.default)(gasPrice));
      passClose(close);

      var walletTypeText = '';
      if (walletType === 'browser') {
        walletTypeText = 'in MetaMask';
      } else if (walletType === 'ledger') {
        walletTypeText = 'on your Ledger';
      } else {
        throw new Error('Unknown wallet type: ' + walletType);
      }

      return _react2.default.createElement(
        'div',
        { className: 'transaction-confirmation' },
        _react2.default.createElement(
          'h2',
          null,
          'Waiting for Confirmation'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Please confirm the following transaction ',
          walletTypeText,
          '.'
        ),
        _react2.default.createElement(
          'div',
          { className: 'transaction' },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                { className: 'address-row' },
                _react2.default.createElement(
                  'td',
                  { className: 'label' },
                  'Contract:'
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'address' },
                    _react2.default.createElement(_EthereumAddress2.default, { address: contract })
                  )
                )
              ),
              tokenAmount && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'label' },
                  'Token Amount:'
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'address amount' },
                  tokenAmount
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'label' },
                  'ETH Amount:'
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'address amount' },
                  (0, _web3Utils.fromWei)(value.toString()),
                  ' ETH'
                )
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'label' },
                  'Gas Fee:'
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'address' },
                  (0, _web3Utils.fromWei)(gasFee),
                  ' ETH'
                )
              ),
              showDetails && _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: 'label' },
                  'Data:'
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'address' },
                  _react2.default.createElement(
                    'div',
                    { className: 'transaction-data' },
                    data
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'toggle ' + (showDetails ? 'open' : 'closed'),
              onClick: this.handleClick
            },
            showDetails ? 'Less Detail' : 'More Detail'
          )
        )
      );
    }
  }]);

  return BrowserPaymentMethod;
}(_react2.default.PureComponent);

BrowserPaymentMethod.displayName = 'BrowserPaymentMethod';

BrowserPaymentMethod.propTypes = {
  transaction: _propTypes2.default.shape({
    transaction: _propTypes2.default.shape({}),
    contract: _propTypes2.default.string.isRequired,
    sendOptions: _propTypes2.default.shape({}).isRequired
  }).isRequired,
  close: _propTypes2.default.func.isRequired,
  passClose: _propTypes2.default.func.isRequired,
  walletType: _propTypes2.default.string.isRequired
};

exports.default = BrowserPaymentMethod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/BrowserPaymentMethod.js
// module id = 1277
// module chunks = 0